export default __webpack_public_path__ + "static/media/warranty.aeee8c31.png";